<mat-toolbar #matToolbar class="p-0 mat-elevation-z1 flex-column">
  <div class="flex-row-start-center fxFlex fxFill">
    <div class="flex-row-space-between-center">
      <button
        mat-icon-button
        class="navbar-toggle-button"
        [ngClass]="!isMediumScreen ? 'hide-menu' : 'show-menu'"
        *ngIf="!hiddenNavbar && !rightNavbar"
        (click)="toggleSidebarOpen('navbar')"
      >
        <mat-icon class="icon-mat-darkmode">menu</mat-icon>
      </button>

      <div class="toolbar-separator" style="width: 2px"></div>
    </div>

    <div class="flex-row-start-center fxFlex search-bar-wrap">
      <fuse-search-bar
        class="fxFlex-100p"
        [loading]="loading"
        (onInput)="autoComplete($event)"
        (onSearch)="search($event)"
      ></fuse-search-bar>

      <!-- TYPE-AHEAD (Meilisearch only — hidden while the fleet is on SQL) -->
      <div
        class="search-suggestions mat-elevation-z8"
        *ngIf="suggestionsOpen"
        role="listbox"
      >
        <div
          *ngFor="let item of suggestions; let i = index"
          class="search-suggestion"
          [class.active]="i === activeSuggestion"
          role="option"
          (mouseenter)="activeSuggestion = i"
          (click)="openSuggestion(item)"
        >
          <mat-icon class="s-20 suggestion-icon">{{
            suggestionIcon(item)
          }}</mat-icon>
          <div class="suggestion-text">
            <div class="suggestion-label" [innerHTML]="item.label_html"></div>
            <div
              class="suggestion-sublabel"
              *ngIf="item.sublabel_html"
              [innerHTML]="item.sublabel_html"
            ></div>
          </div>
        </div>
        <div class="search-suggestions-footer">
          {{ "TOOLBAR.SUGGEST_HINT" | translate }}
        </div>
      </div>

      <div class="toolbar-separator" style="width: 1px"></div>

      <!-- QUICK ORDER (Commande rapide) — only for tenants with the module -->
      <ng-container *ngxPermissionsOnly="P.EVENT_CREATE">
        <button
          mat-button
          *ngIf="modulesService.modulesAreSet && modulesService.hasQuickOrder()"
          #quickOrderMenuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="quickOrderMenu"
          (click)="isMobile && openQuickOrderMenu($event)"
          (mouseenter)="!isMobile && openQuickOrderMenu($event)"
          [matTooltip]="'TOOLBAR.QUICK_ORDER' | translate"
          matTooltipPosition="below"
          class="user-button gt2-amber"
          style="padding: 0; margin: 0"
          aria-label="Commande rapide"
        >
          <mat-icon class="s-32 icon-mat-black">bolt</mat-icon>
        </button>
      </ng-container>

      <mat-menu #quickOrderMenu="matMenu" [overlapTrigger]="false">
        <span (mouseleave)="closeQuickOrderMenu()">
          <button
            class="flex-row-start-center"
            mat-menu-item
            (click)="onNewQuickOrder(); closeQuickOrderMenu()"
          >
            <mat-icon class="fxFlex-13">bolt</mat-icon>
            <span>{{ "TOOLBAR.NEW_PICKUP" | translate }}</span>
          </button>
        </span>
      </mat-menu>

      <button
        mat-button
        *ngxPermissionsOnly="P.MENU_QUICK_CREATE"
        #createMenuButton
        #createMenuTrigger="matMenuTrigger"
        [attr.mobile]="isMobile ? true : null"
        [attr.desktop]="!isMobile ? true : null"
        (click)="isMobile && openMyMenu($event)"
        (mouseenter)="!isMobile && openMyMenu($event)"
        [matMenuTriggerFor]="createMenu"
        class="user-button gt2-light-green"
        style="padding: 0; margin: 0"
      >
        <mat-icon class="s-32 icon-mat-black">add</mat-icon>
      </button>

      <mat-menu
        #createMenu="matMenu"
        (menuClosed)="onMenuClosed()"
        [overlapTrigger]="false"
        class="create-quick-menu"
      >
        <span (mouseleave)="closeMyMenu()" (click)="closeMyMenu()">
          <button
            class="flex-row-start-center"
            mat-menu-item
            (click)="onCreateNewEmployee(); closeMyMenu()"
          >
            <mat-icon class="fxFlex-13">{{
              iconsService.getIcon("EMPLOYEE")
            }}</mat-icon>
            <span>{{ "TOOLBAR.CREATE_EMPLOYEE" | translate }}</span>
          </button>

          <button
            class="flex-row-start-center"
            mat-menu-item
            (click)="onCreateNewProduct(); closeMyMenu()"
          >
            <mat-icon class="fxFlex-13">{{
              iconsService.getIcon("PRODUCT")
            }}</mat-icon>
            <span>{{ "TOOLBAR.CREATE_PRODUCT" | translate }}</span>
          </button>

          <button
            class="flex-row-start-center"
            mat-menu-item
            (click)="onCreateNewProductCombo(); closeMyMenu()"
          >
            <mat-icon class="s-24">bento</mat-icon>
            <span>{{ "TOOLBAR.CREATE_PRODUCT_COMBO" | translate }}</span>
          </button>

          <button
            *ngIf="
              modulesService.modulesAreSet &&
              modulesService.hasComboDynamicModule()
            "
            class="flex-row-start-center"
            mat-menu-item
            (click)="onCreateNewProductComboDynamic(); closeMyMenu()"
          >
            <mat-icon class="s-24">{{
              iconsService.getIcon("COMBO_DYNAMIC")
            }}</mat-icon>
            <span>{{
              "TOOLBAR.CREATE_PRODUCT_COMBO_DYNAMIC" | translate
            }}</span>
          </button>

          <!--<button mat-menu-item (click)="onCreateNewOrder()">-->
          <!--<span>{{ 'TOOLBAR.CREATE_ORDER' | translate }}</span>-->
          <!--</button>-->

          <button
            class="flex-row-start-center"
            mat-menu-item
            (click)="onCreateNewPlace(); closeMyMenu()"
          >
            <mat-icon class="fxFlex-13">{{
              iconsService.getIcon("PLACE")
            }}</mat-icon>
            <span>{{ "TOOLBAR.CREATE_PLACE" | translate }}</span>
          </button>

          <button
            class="flex-row-start-center"
            mat-menu-item
            (click)="onCreateNewEnterprise(); closeMyMenu()"
          >
            <mat-icon class="fxFlex-13">{{
              iconsService.getIcon("ENTERPRISE")
            }}</mat-icon>
            <span>{{ "TOOLBAR.CREATE_ENTERPRISE" | translate }}</span>
          </button>

          <button
            class="flex-row-start-center"
            mat-menu-item
            (click)="onCreateNewClient(); closeMyMenu()"
          >
            <mat-icon class="fxFlex-13">account_circle</mat-icon>
            <span>{{ "TOOLBAR.CREATE_CLIENT" | translate }}</span>
          </button>

          <button
            class="flex-row-start-center"
            mat-menu-item
            (click)="onCreateNewClientEnterprise(); closeMyMenu()"
          >
            <div class="flex-row-center-center">
              <mat-icon class="s-24">user_attributes</mat-icon>
            </div>
            <span>{{ "TOOLBAR.CREATE_CLIENT_ENTERPRISE" | translate }}</span>
          </button>

          <button
            class="flex-row-start-center"
            mat-menu-item
            (click)="onCreateNewMaterial(); closeMyMenu()"
          >
            <mat-icon class="fxFlex-13">{{
              iconsService.getIcon("MATERIAL")
            }}</mat-icon>
            <span>{{ "TOOLBAR.CREATE_MATERIAL" | translate }}</span>
          </button>

          <button
            class="flex-row-start-center"
            mat-menu-item
            (click)="onCreateNewMaterialCombo(); closeMyMenu()"
          >
            <mat-icon class="s-24">bento</mat-icon>
            <span>{{ "TOOLBAR.CREATE_MATERIAL_COMBO" | translate }}</span>
          </button>

          <button
            class="flex-row-start-center"
            *ngIf="
              modulesService.modulesAreSet && !modulesService.hasCTReport()
            "
            mat-menu-item
            (click)="onCreateNewProposal(); closeMyMenu()"
          >
            <!-- <mat-icon class="s-20" fontSet="fa" fontIcon="{{ iconsService.getIcon('PROPOSAL') }}"></mat-icon> -->
            <mat-icon class="fxFlex-13">{{
              iconsService.getIcon("PROPOSAL")
            }}</mat-icon>
            <span fxFlex>{{ "TOOLBAR.CREATE_PROPOSAL" | translate }}</span>
            <span class="menu-shortcut-hint">{{
              isMac ? "⌥⇧P" : "Alt+Shift+P"
            }}</span>
          </button>

          <div
            *ngIf="modulesService.modulesAreSet && modulesService.hasCTReport()"
          ></div>

          <button
            class="flex-row-start-center"
            mat-menu-item
            (click)="onCreateNewOrder(); closeMyMenu()"
          >
            <!-- <mat-icon class="s-20" fontSet="fa" fontIcon="{{ iconsService.getIcon('ORDER') }}"></mat-icon> -->
            <mat-icon class="fxFlex-13">{{
              iconsService.getIcon("ORDER")
            }}</mat-icon>
            <span fxFlex>{{ "TOOLBAR.CREATE_ORDER" | translate }}</span>
            <span class="menu-shortcut-hint">{{
              isMac ? "⌥⇧C" : "Alt+Shift+C"
            }}</span>
          </button>

          <button
            class="flex-row-start-center"
            mat-menu-item
            *ngIf="
              modulesService.modulesAreSet && modulesService.hasCongressModule()
            "
            (click)="onCreateNewCongress(); closeMyMenu()"
          >
            <mat-icon class="fxFlex-13">{{
              iconsService.getIcon("CONGRESS")
            }}</mat-icon>
            <span>{{ "TOOLBAR.CREATE_CONGRES" | translate }}</span>
          </button>
        </span>
      </mat-menu>

      <!-- History, ORDER it's important, after CreateMenu -->
      <div
        *ngIf="!isSmallScreen"
        class="toolbar-separator"
        style="width: 1px"
      ></div>
      <!-- <div>{{histories.length}}</div> -->
      <div class="flex-row-start-center">
        <!-- DISABLED BUTTON MENU -->
        <span
          *ngIf="histories.length == 0"
          class="history-disabled-tooltip-wrapper fx-hide fx-show-gt-xs"
          matTooltip="{{ 'TOOLBAR.NO_HISTORY' | translate }}"
        >
          <button
            mat-button
            class="language-button"
            [matMenuTriggerFor]="historyMenu"
            #historyMenuButtonDisabled
            disabled
          >
            <div class="flex-row-center-center">
              <mat-icon class="s-32 history-disabled">history</mat-icon>
            </div>
          </button>
        </span>
        <!-- ACTIVE BUTTON MENU -->
        <button
          *ngIf="histories.length > 0"
          mat-button
          class="language-button fx-hide fx-show-gt-xs"
          [matMenuTriggerFor]="historyMenu"
          #historyMenuTrigger
          (mouseenter)="!isMobile && openHistoryMenu()"
          matTooltip="{{ 'TOOLBAR.HISTORIES' | translate }}"
        >
          <div class="flex-row-center-center">
            <mat-icon class="s-32" color="rgba(255,255,255,.7)"
              >history</mat-icon
            >
          </div>
        </button>

        <mat-menu
          #historyMenu="matMenu"
          [overlapTrigger]="false"
          class="history-menu-panel"
        >
          <div *ngFor="let lang of histories" class="history-menu-row">
            <button
              mat-menu-item
              (click)="setHistory(lang)"
              class="history-menu-item"
            >
              <mat-icon class="s-32">{{ lang.icon }}</mat-icon>
              <span style="font-size: 12px" class="iso">{{ lang.label }}</span>
            </button>
            <button
              mat-icon-button
              class="history-open-tab"
              (click)="openHistoryInNewTab(lang); $event.stopPropagation()"
              matTooltip="{{ 'TOOLBAR.OPEN_NEW_TAB' | translate }}"
            >
              <mat-icon class="s-24">open_in_new</mat-icon>
            </button>
          </div>
        </mat-menu>

        <!-- Dedicated instance for the mobile nested submenu.
             Sharing #historyMenu between the desktop trigger (still in the DOM
             on mobile, only CSS-hidden) and the mobile nested trigger made the
             submenu open then immediately close. -->
        <mat-menu
          #historyMenuMobile="matMenu"
          [overlapTrigger]="false"
          class="history-menu-panel"
        >
          <div *ngFor="let lang of histories" class="history-menu-row">
            <button
              mat-menu-item
              (click)="setHistory(lang)"
              class="history-menu-item"
            >
              <mat-icon class="s-32">{{ lang.icon }}</mat-icon>
              <span style="font-size: 12px" class="iso">{{ lang.label }}</span>
            </button>
            <button
              mat-icon-button
              class="history-open-tab"
              (click)="openHistoryInNewTab(lang); $event.stopPropagation()"
              matTooltip="{{ 'TOOLBAR.OPEN_NEW_TAB' | translate }}"
            >
              <mat-icon class="s-24">open_in_new</mat-icon>
            </button>
          </div>
        </mat-menu>

        <div
          *ngIf="!isSmallScreen"
          class="toolbar-separator"
          style="width: 2px"
        ></div>
      </div>

      <!--Languages-->
      <div
        *ngIf="!isSmallScreen"
        class="toolbar-separator"
        style="width: 1px"
      ></div>
      <!--<div class="toolbar-separator"></div>-->
      <!-- *ngxPermissionsOnly="['GOD']" -->
      <div class="flex-row-start-center">
        <button
          mat-button
          class="language-button fx-hide fx-show-gt-xs"
          (click)="toggleFullscreen()"
          matTooltip="{{ 'TOOLBAR.FULLSCREEN' | translate }}"
        >
          <div class="flex-row-center-center">
            <mat-icon class="s-24 icon-mat-darkmode">zoom_out_map</mat-icon>
          </div>
        </button>

        <div
          *ngIf="!isSmallScreen"
          class="toolbar-separator"
          style="width: 2px"
        ></div>
      </div>

      <!-- NOTIFICATIONS : cloche du centre de notifications (tous les forfaits, tous les rôles) -->
      <div class="flex-row-start-center">
        <button
          mat-button
          type="button"
          class="language-button bell-button"
          (click)="onBell()"
          [matTooltip]="'TOOLBAR.NOTIFICATIONS' | translate"
          [attr.aria-label]="bellAriaLabel"
          aria-haspopup="dialog"
        >
          <span class="bell-button-icon">
            <mat-icon class="s-24 icon-mat-darkmode" aria-hidden="true">{{
              iconsService.getIcon("NOTIFICATIONS")
            }}</mat-icon>
            <span
              *ngIf="unreadNotifications > 0"
              class="bell-badge"
              aria-hidden="true"
              >{{ bellBadge }}</span
            >
          </span>
        </button>

        <div
          *ngIf="!isSmallScreen"
          class="toolbar-separator"
          style="width: 2px"
        ></div>
      </div>

      <!--USER MENU-->
      <button
        mat-button
        [matMenuTriggerFor]="userMenu"
        #userMenuTrigger
        class="user-button"
        (mouseenter)="!isMobile && openUserMenu()"
      >
        <div class="px-12 flex-row-center-center">
          <img
            *ngIf="employee && (employee.avatar_thumb || isMobile)"
            class="avatar mx-4"
            onerror="
              if (this.src !== '/assets/images/avatars/default-no-avatar.png')
                this.src = '/assets/images/avatars/default-no-avatar.png';
            "
            src="{{ employee.avatar_thumb }}"
          />

          <img
            *ngIf="!employee"
            class="avatar"
            src="assets/images/avatars/profile.jpg"
          />
          <span
            *ngIf="employee"
            maxlength="12"
            class="username employee-name fx-hide fx-show-gt-sm"
          >
            {{
              employee.first_name.length > 11
                ? (employee.first_name | slice: 0 : 11) + "..."
                : employee.first_name
            }}
          </span>
          <mat-icon class="s-16 icon-mat-darkmode fx-hide-xs"
            >keyboard_arrow_down</mat-icon
          >
        </div>
      </button>

      <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
        <span (mouseleave)="!isMobile && closeUserMenu()">
          <button mat-menu-item (click)="onProfile()">
            <mat-icon class="">{{ iconsService.getIcon("PROFILE") }}</mat-icon>
            <span>{{ "TOOLBAR.MY_PROFILE" | translate }}</span>
          </button>

          <!-- Langue : affiche la langue vers laquelle on bascule (« English » en français, « Français » en anglais) -->
          <button mat-menu-item (click)="toggleLang()">
            <mat-icon class="">{{ iconsService.getIcon("LANG") }}</mat-icon>
            <span>{{ selectedLanguage.title }}</span>
          </button>

          <button mat-menu-item (click)="toggleTheme()">
            <mat-icon class="">{{ iconsService.getIcon("DARKMODE") }}</mat-icon>
            <span>{{ modeText }}</span>
          </button>

          <!-- Tous les rôles : préférences de l'utilisateur connecté -->
          <button mat-menu-item (click)="onPreferences()">
            <mat-icon class="">{{
              iconsService.getIcon("PREFERENCES")
            }}</mat-icon>
            <span>{{ "TOOLBAR.PREFERENCES" | translate }}</span>
          </button>

          <button
            *ngxPermissionsOnly="P.CONFIG_ORGANIZATION"
            mat-menu-item
            (click)="onOrganization()"
          >
            <mat-icon class="">account_balance</mat-icon>
            <span>{{ "TOOLBAR.ORGANIZATION" | translate }}</span>
          </button>

          <button
            *ngxPermissionsOnly="P.MENU_SETTINGS"
            mat-menu-item
            (click)="onSettings()"
          >
            <mat-icon class="">{{ iconsService.getIcon("SETTINGS") }}</mat-icon>
            <span>{{ "TOOLBAR.SETTINGS" | translate }}</span>
          </button>

          <button
            *ngIf="isMobile && histories.length !== 0"
            mat-menu-item
            [matMenuTriggerFor]="historyMenuMobile"
          >
            <mat-icon class="" color="rgba(255,255,255,.7)">history</mat-icon>
            <span>{{ "TOOLBAR.HISTORY" | translate }}</span>
          </button>

          <button mat-menu-item (click)="onResetTable()">
            <mat-icon>refresh</mat-icon>
            <span>{{ "TOOLBAR.RESET_TABLE" | translate }}</span>
          </button>

          <button mat-menu-item class="" (click)="onLogout()">
            <mat-icon class="">exit_to_app</mat-icon>
            <span>{{ "TOOLBAR.LOGOUT" | translate }}</span>
          </button>
        </span>
      </mat-menu>

      <div
        *ngIf="!isSmallScreen"
        class="toolbar-separator fx-hide fx-show-gt-xs"
      ></div>

      <!-- Chat panel (demo B) mis de cote — module chat GOD via le menu (T7)
      <ng-container *ngxPermissionsOnly="['GOD']">
        <button
          mat-icon-button
          class="chat-panel-toggle-button"
          (click)="toggleChatPanel()"
          aria-label="Toggle chat panel"
        >
          <mat-icon class="secondary-text">chat</mat-icon>
        </button>

        <div class="toolbar-separator" style="width: 2px"></div>
      </ng-container>
      -->

      <div
        class="toolbar-separator fx-hide fx-show-gt-xs"
        style="width: 2px"
        *ngIf="!hiddenNavbar && rightNavbar && !isSmallScreen"
      ></div>

      <button
        mat-icon-button
        class="navbar-toggle-button fx-hide-gt-md"
        *ngIf="!hiddenNavbar && rightNavbar"
        (click)="toggleSidebarOpen('navbar')"
      >
        <mat-icon class="icon-mat-darkmode">menu</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>
